import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.scss";

import ConnectTripletex from "./pages/ConnectTripletex";
import SyncSettings from "./pages/SyncSettings";
import Subscription from "./pages/Subscription";
import SetupGuide from "./pages/SetupGuide";
import Setup from "./pages/Setup";
import Confirmation from "./pages/Confirmation";
import Retrigger from "./pages/Retrigger";
import CmsNotifications from "./helpers/CmsNotifications";
import Redirect from "./pages/Redirect";
import FinancialIframe from "./pages/FinancialIframe";
import RedirectTripletex from "./pages/RedirectTripletex";

import InfoModal from "./components/modal/InfoModal";
import SuccessModal from "./components/modal/SuccessModal";
import ErrorModal from "./components/modal/ErrorModal";

import { CmsProvider } from "./helpers/cmsHook";

function App() {
  return (
    <CmsProvider>
      <Router>
        <SuccessModal />
        <ErrorModal />
        <InfoModal />
        <Routes>
          <Route path="/connect" element={<ConnectTripletex />} />
          <Route path="/syncSettings" element={<SyncSettings />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/setupguide" element={<SetupGuide />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/retrigger" element={<Retrigger />} />
          <Route path="/edit-notifications" element={<CmsNotifications />} />
          <Route path="/redirect" element={<Redirect />} />
          <Route path="/financial" element={<FinancialIframe />} />
          <Route path="/redirectTripletex" element={<RedirectTripletex />} />
        </Routes>
      </Router>
    </CmsProvider>
  );
}

export default App;
